import { isExpired } from "../../helper";

export const validateRequest = (
  formData,
  passengers,
  guests,
  setError,
  sapErrorList
) => {
  let isError = false;
  if (!formData.to) {
    setError((prev) => ({ ...prev, to: "Please select destination" }));
    isError = true;
  }

  if (!formData.from) {
    setError((prev) => ({ ...prev, from: "Please select from" }));
    isError = true;
  }

  if (formData.from === formData.to) {
    setError((prev) => ({ ...prev, to: "Destination can't be same as From" }));
    isError = true;
  }

  if (!(formData.departureTime || formData.returnTime)) {
    setError((prev) => ({
      ...prev,
      departureTime: "Please select return & departure time",
    }));
    isError = true;
  } else if (!formData.departureTime) {
    setError((prev) => ({
      ...prev,
      departureTime: "Please select preferred departure time",
    }));
    isError = true;
  } else if (!formData.returnTime && formData.returnJourney) {
    setError((prev) => ({
      ...prev,
      returnTime: "Please select preferred return time",
    }));
    isError = true;
  }

  if (formData.returnJourney) {
    if (!(formData.departureDate || formData.returnDate)) {
      setError((prev) => ({
        ...prev,
        departureReturnDate: "Please select departure and return date",
      }));
      isError = true;
    } else if (!formData.returnDate) {
      setError((prev) => ({
        ...prev,
        departureReturnDate: "Please select return date",
      }));
      isError = true;
    } else if (!formData.departureDate) {
      setError((prev) => ({
        ...prev,
        departureReturnDate: "Please select departure date",
      }));
      isError = true;
    }
  } else if (!formData.returnJourney) {
    if (!formData.departureDate) {
      setError((prev) => ({
        ...prev,
        departureReturnDate: "Please select departure date",
      }));
      isError = true;
    }
  }

  // let selectedAirlines = formData.perferAirline.filter((item) => item.selected);
  // if (selectedAirlines.length === 0) {
  //   setError((prev) => ({
  //     ...prev,
  //     perferAirline: "Please select preferred airlines",
  //   }));
  //   isError = true;
  // }

  let selectedPax = passengers.filter((item) => item.selected);
  if (selectedPax.length === 0 && guests.length === 0) {
    setError((prev) => ({
      ...prev,
      passengers: "Please select the passengers who will travel.",
    }));
    isError = true;
  } else {
    if (selectedPax.length > 0) {
      let passengersErrors = [];
      for (let i = 0; i < passengers.length; i++) {
        passengersErrors.push({
          paymentType: "",
          travelType: "",
        });
        let data = passengersErrors;
        // let eachSapError =
        //   sapErrorList[i].passportExpirationDate &&
        //   sapErrorList[i].passportNumber &&
        //   sapErrorList[i].passportPdf&&
        //   !sapErrorList[i].isExpired

        if (passengers[i].selected && passengers[i].paymentType === "") {
          data[i].paymentType = "Please select payment type";
          setError((prev) => ({
            ...prev,
            passengers: data,
          }));
          isError = true;
        }
        if (passengers[i].selected && passengers[i].travelType === "") {
          data[i].travelType = "Please select travel class";
          setError((prev) => ({
            ...prev,
            passengers: data,
          }));
          isError = true;
        }
        if (
          passengers[i].selected &&
          passengers[i].relationshipStatus !== "Self" &&
          passengers[i].passportNo === ""
        ) {
          data[i].passportNo = "Please enter passport number";
          setError((prev) => ({
            ...prev,
            passengers: data,
          }));
          isError = true;
        }
        if (
          passengers[i].selected &&
          passengers[i].relationshipStatus !== "Self" &&
          passengers[i].passportExpiry === ""
        ) {
          data[i].passportExpiry = "Please select passport expiry date";
          setError((prev) => ({
            ...prev,
            passengers: data,
          }));
          isError = true;
        } else if (
          passengers[i].selected &&
          passengers[i].relationshipStatus !== "Self" &&
          isExpired(passengers[i].passportExpiry)
        ) {
          data[i].passportExpiry = "Passport expired, please update..";
          setError((prev) => ({
            ...prev,
            passengers: data,
          }));
          isError = true;
        }
        if (
          passengers[i].selected &&
          passengers[i].relationshipStatus !== "Self" &&
          passengers[i].passportPdf === ""
        ) {
          data[i].passportPdf = "Please upload passport pdf";
          setError((prev) => ({
            ...prev,
            passengers: data,
          }));
          isError = true;
        }
        // if (passengers[i].selected && !eachSapError) {
        //   isError = true;
        // }
      }
    }
    if (guests.length > 0) {
      let guestsErrors = [];
      for (let i = 0; i < guests.length; i++) {
        guestsErrors.push({
          firstName: "",
          lastName: "",
          paymentType: "",
          travelType: "",
          passportNo: "",
          passportExpiry: "",
        });
        let data = guestsErrors;
        if (guests[i].firstName === "") {
          data[i].firstName = "Please enter first name";
          setError((prev) => ({
            ...prev,
            guests: data,
          }));
          isError = true;
        }
        // if (guests[i].lastName === "") {
        //   data[i].lastName = "Please enter last name";
        //   setError((prev) => ({
        //     ...prev,
        //     guests: data,
        //   }));
        //   isError = true;
        // }
        if (guests[i].paymentType === "") {
          data[i].paymentType = "Please select payment type";
          setError((prev) => ({
            ...prev,
            guests: data,
          }));
          isError = true;
        }
        if (guests[i].travelType === "") {
          data[i].travelType = "Please select travel class";
          setError((prev) => ({
            ...prev,
            guests: data,
          }));
          isError = true;
        }
        if (guests[i].passportNo === "") {
          data[i].passportNo = "Please enter passport number";
          setError((prev) => ({
            ...prev,
            guests: data,
          }));
          isError = true;
        }
        if (guests[i].passportExpiry === "") {
          data[i].passportExpiry = "Please select passport expiry";
          setError((prev) => ({
            ...prev,
            guests: data,
          }));
          isError = true;
        }
        if (guests[i].dob === "") {
          data[i].dob = "Please select date of birth";
          setError((prev) => ({
            ...prev,
            guests: data,
          }));
          isError = true;
        }
        if (guests[i].passportPdf === "") {
          data[i].passportPdf = "Please upload passport pdf";
          setError((prev) => ({
            ...prev,
            guests: data,
          }));
          isError = true;
        }
      }
    }
  }
  return isError;
};

export const sapErrorValidation = (passengers, sapErrorList) => {
  let isError = false;

  for (let i = 0; i < passengers.length; i++) {
    if (
      passengers[i].selected &&
      passengers[i].relationshipStatus === "Self" &&
      sapErrorList[i] !== ""
    ) {
      isError = true;
    }
  }
  return isError;
};
